<template>
  <edit></edit>
</template>

<script>
import edit from './app_style_temp_edit.vue'
export default {
  name: 'b_app_style_add',

  components: {
    edit
  }
}
</script>